<template>
  <aside class="menu" v-show="isMenuVisible">
    <b-row>
      <b-col cols="6">
        <div class="menu-filter">
          <i class="fa fa-search fa-lg"></i>
          <input
            type="text"
            placeholder="Digite para filtrar..."
            v-model="treeFilter"
            class="filter-field"
          />
        </div>

        <b-row>
          <b-col sm="4">
            <label for="input-parecer">Grupo de usuário</label> --
            {{ grupoUsuario.id_grupo }}
            <div>
              <b-form-select
                id="grupo"
                :options="grupoUsuarios"
                v-model="grupoUsuario.id_grupo"
                @change="getMenuLiberadoGrupo"
                class="mb-3"
                text-field="grupo"
                value-field="id_grupo"
              >
              </b-form-select>
            </div>
          </b-col>
        </b-row>

        <Tree
          v-if="treeData.length"
          :data="treeData"
          :options="treeOptions"
          :filter="treeFilter"
          :checked-keys="checkedKeys"
          ref="tree"
        />
      </b-col>
      <b-col cols="6">
        <div class="menu-filter">
          <i class="fa fa-search fa-lg"></i>
          <input
            type="text"
            placeholder="Digite para filtrar..."
            v-model="treeFilter"
            class="filter-field"
          />
        </div>

        <Tree
          v-if="itensMenuGrupos.length"
          :data="itensMenuGrupos"
          :options="treeOptionsLiberado"
          :filter="treeFilter"
          :checked-keys="checkedKeys"
          ref="tree"
        />
      </b-col>
    </b-row>
  </aside>
</template>

<script>
import { mapState } from "vuex";
import Tree from "liquor-tree";
import { baseApiUrl } from "@/global";
import axios from "axios";

export default {
  name: "Menu",
  components: { Tree },

  computed: {
    ...mapState(["isMenuVisible", "user"]),
  },

  data() {
    return {
      treeFilter: "",

      treeOptions: {
        propertyNames: {
          text: "name",
          checked: "checked",
          children: "children",
        },
        checkbox: true,
        checkboxStrategy: "all", // pai e filho podem ser marcados
        filter: { emptyText: "Categoria não encontrada" },
      },

      treeOptionsLiberado: {
        propertyNames: {
          text: "name",
          checked: "checked",
          children: "children",
        },
        checkbox: true,
        checkboxStrategy: "all", // pai e filho podem ser marcados
        filter: { emptyText: "Categoria não encontrada" },
      },

      treeData: [],
      checkedKeys: [], // ids marcados na árvore
      grupoUsuario: { id_grupo: null }, // inicializado para garantir reatividade
      grupoUsuarios: [], // lista de grupos do usuário

      itensMenuEmpresa: [],
      itensMenuGrupos: [],
    };
  },

  methods: {
    async loadGrupo() {
      try {
        const corpo = { id_empresa: this.user.id_empresa };
        const url = `${baseApiUrl}/users/grupo`;
        const res = await axios.post(url, corpo);
        this.grupoUsuarios = res.data.map((tpl) => ({
          ...tpl,
          value: tpl.id_grupo,
          grupo: tpl.grupo,
          id_grupo: tpl.id_grupo,
        }));

        if (this.grupoUsuarios.length) {
          // Atualiza só o id_grupo para manter reatividade
          this.grupoUsuario.id_grupo = this.grupoUsuarios[0].id_grupo;
          await this.getMenuLiberadoGrupo();
        }
      } catch (error) {
        console.error("Erro ao carregar grupos:", error);
      }
    },

    async getTreeData() {
      try {
        const corpo = {
          id_empresa: this.user.id_empresa,
          id_grupo: this.user.id_grupo, // perfil do usuário
        };
        const url = `${baseApiUrl}/permissao/menu/menuEmpresa`;
        const res = await axios.post(url, corpo);
        const menusEmpresa = res.data;

        // Monta a árvore recursiva, sem checked dinâmico
        const montarArvore = (lista, parentId = null) => {
          return lista
            .filter((menu) => (menu.parentId ?? null) === parentId)
            .map((menu) => ({
              id: menu.id,
              name: menu.name,
              checked: false, // nenhum nó chega marcado
              children: montarArvore(lista, menu.id),
            }));
        };

        this.treeData = montarArvore(menusEmpresa);
      } catch (error) {
        console.error("Erro ao buscar menus:", error);
        this.treeData = [];
      }
    },

    async getMenuLiberadoGrupo() {
      this.itensMenuGrupos = [];
      try {
        const corpo = {
          id_empresa: this.user.id_empresa,
          id_grupo: this.grupoUsuario.id_grupo, // perfil do usuário
        };
        const url = `${baseApiUrl}/permissao/menu/itensliberadoGrupo`;
        const res = await axios.post(url, corpo);
        const menuLiberado = res.data;

        // Monta a árvore recursiva, sem checked dinâmico
        const montarArvore = (lista, parentId = null) => {
          return lista
            .filter((menu) => (menu.parentId ?? null) === parentId)
            .map((menu) => ({
              id: menu.id,
              name: menu.name,
              checked: false, // nenhum nó chega marcado
              children: montarArvore(lista, menu.id),
            }));
        };

        this.itensMenuGrupos = montarArvore(menuLiberado);
      } catch (error) {
        console.error("Erro ao buscar menus:", error);
        this.itensMenuGrupos = [];
      }
    },

    onNodeSelect(node) {
      this.$router.push({ name: node.id });
      if (this.$mq === "xs" || this.$mq === "sm") {
        this.$store.commit("toggleMenu", false);
      }
    },

    async onNodeCheckChange(node, checked) {
      try {
        const url = `${baseApiUrl}/users/grupoPermissao`;

        if (!node.children || node.children.length === 0) {
          const body = {
            id_grupo: this.grupoUsuario.id_grupo,
            id_menu: node.id,
            id_grupo_empresa: this.user.id_grupo_empresa,
            id_empresa: this.user.id_empresa,
            id_filial: this.user.id_filial,
            permitido: checked,
          };
          await axios.post(url, body);
        }

        if (!checked && node.parent) {
          const body = {
            id_grupo: this.grupoUsuario.id_grupo,
            id_menu: node.parent.id,
            id_grupo_empresa: this.user.id_grupo_empresa,
            id_empresa: this.user.id_empresa,
            id_filial: this.user.id_filial,
            permitido: false,
          };
          await axios.post(url, body);
        }

        if (checked && node.parent) {
          const allChecked = node.parent.children.every(
            (child) => child.checked
          );
          if (allChecked) {
            const body = {
              id_grupo: this.grupoUsuario.id_grupo,
              id_menu: node.parent.id,
              id_grupo_empresa: this.user.id_grupo_empresa,
              id_empresa: this.user.id_empresa,
              id_filial: this.user.id_filial,
              permitido: true,
            };
            await axios.post(url, body);
          }
        }

        console.log(
          `Permissão ${checked ? "liberada" : "removida"} para ${node.name}`
        );
        this.getMenuLiberadoGrupo();
      } catch (error) {
        console.error("Erro ao atualizar permissão:", error);
      }
    },
  },

  watch: {
    treeData(newVal) {
      if (newVal.length > 0) {
        this.$nextTick(() => {
          if (this.$refs.tree) {
            // Remove antes os handlers para evitar duplicação
            this.$refs.tree.$off("node:selected");
            this.$refs.tree.$off("node:checked");
            this.$refs.tree.$off("node:unchecked");

            this.$refs.tree.$on("node:selected", this.onNodeSelect);
            this.$refs.tree.$on("node:checked", (node) =>
              this.onNodeCheckChange(node, true)
            );
            this.$refs.tree.$on("node:unchecked", (node) =>
              this.onNodeCheckChange(node, false)
            );
          } else {
            console.warn("Tree ref não encontrado no DOM.");
          }
        });
      }
    },
  },

  async mounted() {
    await this.loadGrupo();
    await this.getTreeData();
  },
};
</script>

<style>
.menu {
  grid-area: menu;
  background: linear-gradient(to right, #def0f8, #303233);
  display: flex;
  flex-direction: column;
}

.menu a,
.menu a:hover {
  color: #070707;
  text-decoration: none;
}

.menu .tree-node.selected > .tree-content,
.menu .tree-node .tree-content:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.tree-arrow.has-child {
  filter: brightness(2);
}

.menu .menu-filter {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #aaaaaa;
}

.menu .menu-filter i {
  color: #2908e6;
  margin-right: 10px;
}

.menu input {
  color: #0c50aa;
  font-size: 1.3rem;
  border: 0;
  outline: 0;
  width: 100%;
  background: transparent;
}

.tree-filter-empty {
  color: #ccc;
  font-size: 1.1rem;
  margin-left: 20px;
}
</style>
